import type { IServiceJourney } from '../../../../models/service-journey.model';
import { DirectionDetails } from './direction-details.api-model';
import { LineApiModel } from './line.api-model';

export class ServiceJourneyApiModel {
  public static mapToBusinessModel(apiModel: ServiceJourneyApiModel): IServiceJourney {
    const line = LineApiModel.mapToBusinessModel(apiModel.line);
    return {
      gid: apiModel.gid,
      number: apiModel.number,
      line: { ...line, directionName: line.directionName ?? apiModel.direction }, // If the line does not contain a direction name, use the API model's direction
      direction: apiModel.direction,
      directionDetails: apiModel.directionDetails ? DirectionDetails.mapToBusinessModel(apiModel.directionDetails) : undefined,
      isRealtimeJourney: apiModel.line.isRealtimeJourney,
    };
  }

  public gid!: string;
  public number: string | undefined;
  public line!: LineApiModel;
  public direction!: string;
  public directionDetails!: DirectionDetails;
}
